import {Types}         from "@Common/types";
import {Fetcher}       from "@Common/utils/browser/fetcher";
import {buildUrlQuery} from "@Common/utils/build-url-query";
import {chain}         from "@Common/utils/fs";

export const CcApis3 = ({host, headers=undefined}) => {
    // console.log("CcApis3 host", host);
    const authFetcher = chain(
        Fetcher({
            host,
            headers,
        }),
        (fetcher) => ({
            postJson: nullException(fetcher.postJson),
            getJson: nullException(fetcher.getJson),
            postMultipart: nullException(fetcher.postMultipart),
        })
    );

    return ({
        currentHost: host,
        scriptUrl: host + "/Resources/Generated/IframeApi.js",
        getHost: async(params:Types.Apis.Payloads.CC.GetHostRequest): Promise<Types.Apis.Payloads.CC.GetHostResponse> => {
            // if the editor is already loaded, then use the current editor domain - this accounts for issues causing
            // full page refreshes when using `npm run fast`
            if (window["CustomersCanvas"]?.IframeApi?.editorUrl
                && window["CustomersCanvas"]?.IframeApi?.Editor?.version
            ) {
                return {
                    ccHost: window["CustomersCanvas"].IframeApi.editorUrl,
                    ccVersion: window["CustomersCanvas"]?.IframeApi?.Editor?.version.split(".")[0]
                };
            }
            // when editor is not loaded, fetch the domain from the server
            return await authFetcher.getJson("/xdapi/api/get-host" + buildUrlQuery(params))
        },

        getTemplateConf: async (params:Types.Apis.Payloads.CC.GetTemplateConfRequest): Promise<Types.Apis.Payloads.CC.GetTemplateConfResponse> =>
            authFetcher.postJson("/xdapi/api/get-template-conf", params),
        authenticateState: async (stateId:string): Promise<Types.Apis.Payloads.CC.AuthenticateStateResponse> =>
            authFetcher.getJson("/xdapi/api/authenticate-state" + buildUrlQuery({state_id: stateId})),
        getLowResProducts: async (params:Types.Apis.Payloads.CC.GetLowResProductsRequest): Promise<Types.Apis.Payloads.CC.GetLowResProductsResponse> =>
            authFetcher.postJson("/xdapi/api/render/" + params.userId + "/" + params.stateId, {
                format: ["jpg"],
                numSurfaces: params.surfaceCount
            }),
        getWatermarkPdf: async (params:Types.Apis.Payloads.CC.GetWatermarkPdfRequest): Promise<Types.Apis.Payloads.CC.GetWatermarkPdfResponse> =>
            authFetcher.postJson("/xdapi/api/render/" + params.userId + "/" + params.stateId, {
                format: ["watermarkPdf"],
                numSurfaces: params.surfaceCount,
                variableData: params.mergeFields
            }),
        getHighResProducts: async (params:Types.Apis.Payloads.CC.GetHighResProductsRequest): Promise<Types.Apis.Payloads.CC.GetHighResProductsResponse> =>
            authFetcher.postJson("/xdapi/api/render/" + params.userId + "/" + params.stateId, {
                format: params.format ?? ["pdf", "highResJpg"],
                numSurfaces: params.surfaceCount,
                rotations: params.rotations,
                variableData: params.mergeFields
            }),
        getHighResProducts1: async ({templateId}) => {
            // returns {jpg: ["url",]}
            return await authFetcher.postJson("/xdapi/api/render/" + templateId, {
                format: ["highResJpg"],
                // numSurfaces: params.surfaceCount,
                // rotations: params.rotations,
                // variableData: params.mergeFields
            });
        },
        checkImages: async (imageUrls): Promise<Types.Apis.Payloads.CC.CheckImagesResponse> =>
            authFetcher.postJson("/xdapi/api/check-availability", {urls: imageUrls}),
        cloneState: async (formData): Promise<Types.Apis.Payloads.CC.CloneStateResponse> =>
            authFetcher.postJson("/xdapi/api/clone-state", formData),
        deleteState: async (stateId): Promise<Types.Apis.Payloads.CC.DeleteStateResponse> =>
            authFetcher.getJson("/xdapi/api/delete-state" + buildUrlQuery({state_id: stateId})),
        cloneUserCreatedIdmls: async (formData): Promise<Types.Apis.Payloads.CC.CloneIdmlResponse> =>
            authFetcher.postJson("/xdapi/api/clone-user-created-idmls", formData),
        uploadImageToGallery: async (formData): Promise<Types.Apis.Payloads.CC.UploadImageToGalleryResponse> =>
            authFetcher.postMultipart("/xdapi/api/gallery/upload", formData),
        getToken: async (): Promise<Types.Apis.Payloads.CC.GetTokenResponse> =>
            authFetcher.getJson("/xdapi/api/get-internal-cc-token"),
        saveStateAttributes: async (stateId:string, stateData:Types.Apis.Payloads.CC.SaveStateAttributesRequest): Promise<void> => {
            authFetcher.postJson("/xdapi/api/save-state-attributes/" + stateId, stateData); }, // TODO: return boolean based on https status after fetcher is adjusted to support it
    });

}

const nullException = (fn) => async (...args) => {
    try {
        return await fn(...args);
    } catch (e) {
        return null;
    }
};
